export const DEFAULT_FIRST_LOGIN_EXCLUSIVE_PATHS = ['/subscription'];
export const PAGE_NAMES = {
  '/': 'Dashboard',
  '/leaderboard': 'Leaderboard',
  '/special-offers': 'Special Offers',
  '/club-store': 'Club Store',
  '/flash-market/1': 'Flash Market',
  '/flash-market/2': 'Flash Market',
  '/web-coin-shop': 'Web Coin Shop',
  '/calendar': 'Calendar',
  '/news': 'News',
  '/superstar-database': 'Superstar Guide',
  '/limited-time-events': 'Events',
  '/trivia-rumble': 'Trivia Rumble',
  // '/tournament': 'Tournament',
};

export const SOCIAL_LINKS_MENU = [
  {
    key: 'facebook',
    url: 'https://www.facebook.com/wwechampionsgame',
    icon: 'facebook',
  },
  {
    key: 'youtube',
    url: 'https://www.youtube.com/channel/UCpzDYtjZe7RtUzxgpYXyOrw',
    icon: 'youtube',
  },
  {
    key: 'twitter',
    url: 'https://twitter.com/WWEChampions',
    icon: 'twitter',
  },
];
